import './dependencies/index';
import './templates/templates';
import './templates/partials';
import './utils/handlebars-helper';

import { login } from './login'
import { loadFragment } from './utils/utils'
import { startMap } from './map';
import initServiceWorker from './worker/subscribe-updates';
import { MINUTE_IN_MS } from './utils/enum';
import startApp from './core/gendloc.app';
import { Storage, STORAGE_KEYS } from './utils/store';
import { GendLocWebsockets } from './core/websocket.engine';
import { registerNotificationWs } from './core/notification-ws';
import AuthGuard from './core/auth/auth-guard';

/**
 * Au chargement de la page on vérifie si l'utilisateur est authentifié.
 * Selon le résultat on charge soit la page de login,
 * soit la carte.
 */
window.onload = async () => {
    initServiceWorker();

    if (await AuthGuard.isAuthenticated()) {
        loadFragment('./map.html', () => {
            startApp().then(app => {
                const notificationWs = GendLocWebsockets.notification;

                registerNotificationWs(app, notificationWs);

                startMap(
                    new URLSearchParams(window.location.search),
                    app
                );
            });
        });
    } else {
        loadFragment(
            './login.html',
            () => {
                Storage.clear(STORAGE_KEYS.APP_INITIALIZED, localStorage);

                document.getElementById('login').onclick = login;
                document.addEventListener('keypress', (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        login();
                    }
                });
            }
        );
    }
};
